export default "__VITE_ASSET__CGfJ3zpa__"